import { useState } from "react";
import { toast } from "sonner";
import axios from "axios";
import { API } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowRight, Loader2 } from "lucide-react";

export const NewsletterForm = ({ variant = "default" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      const response = await axios.post(`${API}/newsletter/subscribe`, { email });
      if (response.data.already_subscribed) {
        toast.info("You're already subscribed");
      } else {
        toast.success("Welcome to Somalume");
      }
      setEmail("");
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (variant === "minimal") {
    return (
      <form onSubmit={handleSubmit} className="flex gap-2" data-testid="newsletter-form-minimal">
        <Input
          type="email"
          placeholder="Your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="bg-transparent border-white/10 focus:border-gold/40 text-[#EAEAEA] placeholder:text-[#A1A1AA] rounded-none"
          data-testid="newsletter-email-input"
          required
        />
        <Button
          type="submit"
          disabled={loading}
          className="bg-gold text-[#050505] hover:bg-gold-accent rounded-none px-6"
          data-testid="newsletter-submit-btn"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : <ArrowRight size={16} />}
        </Button>
      </form>
    );
  }

  return (
    <div className="glass-gold p-8 rounded-sm" data-testid="newsletter-form">
      <h3 className="font-heading text-2xl text-[#EAEAEA] mb-2">
        Begin the journey
      </h3>
      <p className="text-[#A1A1AA] text-sm mb-6">
        Receive a free chapter from Cosmic Anatomy and stay connected with Somalume teachings.
      </p>
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="flex-1 bg-transparent border-white/10 focus:border-gold/40 text-[#EAEAEA] placeholder:text-[#A1A1AA] rounded-none h-12"
          data-testid="newsletter-email-input"
          required
        />
        <Button
          type="submit"
          disabled={loading}
          className="bg-gold text-[#050505] hover:bg-gold-accent rounded-none h-12 px-8 uppercase text-xs tracking-widest btn-shine"
          data-testid="newsletter-submit-btn"
        >
          {loading ? (
            <Loader2 size={16} className="animate-spin" />
          ) : (
            <>Get Free Chapter<ArrowRight size={16} className="ml-2" /></>
          )}
        </Button>
      </form>
      <p className="text-[#A1A1AA] text-xs mt-4">
        No spam. Unsubscribe anytime.
      </p>
    </div>
  );
};

export default NewsletterForm;
